export interface Environment {
  id: string
  production: boolean
  apiUrl: string
  keycloak: {
    url: string
    realm: string
    clientId: string
    providers: {
      idpHint: string
      enabled: boolean
    }[]
  }
  recaptchaSiteKey: string
  flags?: FeatureFlag[]
}

export enum FeatureFlag {
  DEMO_PAGE = 'DEMO_PAGE',
  QQX_LANGUAGE = 'QQX_LANGUAGE',
  SUBSCRIPTION_SELF_SERVICE = 'SUBSCRIPTION_SELF_SERVICE',
  SEAT_MANAGEMENT = 'SEAT_MANAGEMENT',
  KEYCLOAK_INTEGRATION = 'KEYCLOAK_INTEGRATION',
}
